/* eslint 'array-callback-return': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import AddRequest from '../_ModalsForms/AddRequest';
import { GetAllRequests, DeleteTenantRequests, GetAllPastRequests } from '../../../../../action/requestAction';
import { makeGetCall } from '../../../../../action/tenantAction';
import { connect } from "react-redux";
import SelectAllCheckboxes from '../../../../../Resources/SelectAllCheckboxes';
import SearchInput, { createFilter } from 'react-search-input';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import * as ErrorMessage from '../../../../../Resources/ErrorMessages';
import DeleteConfirmation from '../_ModalsForms/DeleteConfirmation';
import DatePicker from 'react-datepicker';
import DatePickerCustom from '../../../../common/DatePicker';
import TimeString from '../../../../../Resources/Conversions';
import Conversions from '../../../../../Resources/Conversions';
import LoadingIndicator from '../../../Common/LoadingIndicator';
import ReactPaginate from 'react-paginate';

const KEYS_TO_FILTERS = ['tenantName', 'zoneName', 'buildingName', 'createdBy', 'startDateTime', 'stopDateTime'];
let pagesCount = 0;

class Requests extends Component {

    async componentDidMount() {
        const Tenants = this.props.GetAllRequests();
        const Requests = this.props.makeGetCall();
        await Promise.all([Tenants, Requests]);
        this.setState({ isloading: false });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps && nextProps.RequestList_Response !== undefined) {
            let RequestList = [], PastRequestList = []; 
            if(this.state.FilterValue === "1" || this.state.FilterValue === "3"){
                RequestList = nextProps.RequestList_Response.map(activerequest => ({ ...activerequest, IsPastRequest: false }));
            }
            if((this.state.FilterValue === "2" || this.state.FilterValue === "3") && nextProps.PastRequest !== undefined){
                PastRequestList = nextProps.PastRequest.map(pastrequest => ({ ...pastrequest, IsPastRequest: true }));
            }  
            this.setState({ requestList_in_state: [...RequestList, ...PastRequestList] });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            requestList_in_state: null,
            modal: false,
            deletemodal: false,
            error_msg: false,
            sortOption: 'Asc',
            sortColumn: 'Date',
            SelectedRequest: [],
            RequestId: 0,
            TenantId: 0,
            TenantName: '',
            zoneName: '',
            Loading: false,
            searchTerm: '',
            startDate: null,
            endDate: null,           
            sort: {
                column: null,
                direction: [
                    { name: 'tenantName', direction: 'desc', onclick: false },
                    { name: 'zoneName', direction: 'desc', onclick: false },
                    { name: 'startDateTime', direction: 'asc', onclick: true },
                    { name: 'Time', direction: 'desc', onclick: false },
                    { name: 'createdBy', direction: 'desc', onclick: false }
                ]
            },
            IsDefaultSort: true,
            IsPastRequest: false,
            FilterValue: "1",            
            currentPage: 0,
            pageSize: 50,
        }
        this.toggle = this.toggle.bind(this);
        this.CloseModal2 = this.CloseModal2.bind(this);
        this.LoadRequestForEdit = this.LoadRequestForEdit.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
        this.deleteRequests = this.deleteRequests.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.datefilter = this.datefilter.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    CloseModal = () => {
        this.setState({
            RequestId: 0,
            TenantId: 0,
            TenantName: '',
            zoneName: '',
            IsPastRequest: false
        });
        this.toggle();
    }

    CloseModal2() {
        this.setState({
            RequestId: 0,
            TenantId: 0,
            TenantName: '',
            zoneName: '',
            IsPastRequest: false
        });
        this.toggle();
    }

    LoadRequest = () => {
        this.props.GetAllRequests();
        this.setState({
            modal: false
        });
    }

    /* Edit Request */
    LoadRequestForEdit(e, l_IsPastRequest) {
        let l_SelectedRequest = [];
        if (l_IsPastRequest) {
            l_SelectedRequest = this.props.PastRequest.filter(el => el.requestId == e)[0];
        } else {
            l_SelectedRequest = this.props.RequestList_Response.filter(el => el.requestId == e)[0];
        }
        this.setState({
            RequestId: e,
            TenantId: l_SelectedRequest.tenantId,
            TenantName: l_SelectedRequest.tenantName,
            zoneName: l_SelectedRequest.zoneName,
            IsPastRequest: l_IsPastRequest
        });
        this.toggle();
    }

    /* Delete System */
    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    deleteRequests() {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('RequestRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }

    /* Delete Confirmation*/
    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('RequestRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var tenant_id_to_be_deleted = {
                        "requestId": checkboxes[i].id
                    }
                    Data.push(tenant_id_to_be_deleted);
                }
            }

            if (Data.length > 0) {
                this.setState({ error_msg: false });
                this.props.DeleteTenantRequests(Data);
                this.Deletetoggle();
            }
        }
        else {
            this.Deletetoggle();
        }
    }

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTerm: term, currentPage: 0 })
    }

    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
         var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
         if(scrollPageTop[0] !== undefined){
             (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
         }
    };

    /* Sorting  System */
    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';

        //const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        var notequals = 0;

        var data_from_state = this.state.requestList_in_state;
        if (data_from_state != null) {
            const sortedData = this.state.requestList_in_state.sort((a, b) => {

                const nameA = (column == 'Time') ? (parseInt(new Date(a['startDateTime']).getHours() * 60) + parseInt(new Date(a['startDateTime']).getMinutes())) : a[column].toLowerCase();
                const nameB = (column == 'Time') ? (parseInt(new Date(b['startDateTime']).getHours() * 60) + parseInt(new Date(b['startDateTime']).getMinutes())) : b[column].toLowerCase();
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });


            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();

            }
            SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
            SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

            this.setState({
                requestList_in_state: sortedData,
                sort: {
                    column,
                    direction : SortData,
                }
            });
        }
    };

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };

    /*    Date Filer System     */
    handleChange(date) {
        this.setState({
            startDate: date ,  currentPage: 0
        });
    }

    handleChange2(date) {
        this.setState({
            endDate: date ,  currentPage: 0
        });
    }

    datefilter() {
        let fromDate, toDate, data = null;
        let FilteredData = [];

        var from = this.state.startDate;
        var to = this.state.endDate;

        if (from != null && to != null) {
            fromDate = new Date(this.state.startDate);
            toDate = new Date(this.state.endDate);
            data = this.state.requestList_in_state;

            data.filter(function (e) {
                var aDate = new Date(new Date(e.startDateTime).setHours(0,0,0,0));
                if (aDate >= fromDate && aDate <= toDate) {
                    FilteredData.push(e);
                }
            });
            if (FilteredData.length != 0) {
                var column = this.state.sort.direction.filter(x => x.onclick === true)[0].name;
                var sortDirection = this.state.sort.direction.filter(x => x.name === column)[0].direction;
                    const sortFilteredData = FilteredData.sort((a, b) => {
                        const nameA = (column == 'Time') ? (parseInt(new Date(a['startDateTime']).getHours() * 60) + parseInt(new Date(a['startDateTime']).getMinutes())) : a[column].toLowerCase();
                        const nameB = (column == 'Time') ? (parseInt(new Date(b['startDateTime']).getHours() * 60) + parseInt(new Date(b['startDateTime']).getMinutes())) : b[column].toLowerCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    });
        
                    if(sortDirection === "desc")
                        sortFilteredData.reverse();
                return sortFilteredData;
            }
        }
        return;
    }

    OnFilterChange = () => {
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;
        this.setState({ FilterValue: lFilterId,  currentPage: 0 });
        this.props.GetAllPastRequests(null, null);
    }

    render(RequestList_Response, Tenant_List_Response, getLabels, UserPreference_response, UserCanEdit) {
        let data, FilteredData, Error_Message = null, lUserCanEdit, Filters_in_Select_input;
        let Request_List, Default_Tenant_Id = 0;
        let lRequestlength = 0, lCurrentRequestlength = 0;
        let label = this.props.getLabels;

        let PreferedDateFormat = this.props.UserPreference_response;
        let UserFormat = Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);

        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

        if (label['AfterHours.Filters.Options.Text'] !== undefined) {
            var Filetrs = label['AfterHours.Filters.Options.Text'].split(',');
            Filters_in_Select_input = Filetrs.map(el => (
                <option id={el} value={el} >{label['AfterHours.Filters.Options.' + el + '.Text']}</option>
            ));
        }

        data = this.state.requestList_in_state;

        if (this.state.startDate != null && this.state.endDate != null) {
            data = this.datefilter();
        }

        if (data != undefined && data.length > 0 && data != null && !this.state.isloading) {
            if(this.state.IsDefaultSort){
                data.sort((a,b)=>{
                    let nameA = a['startDateTime'].toLowerCase();
                    let nameB = b['startDateTime'].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
            }

            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            lRequestlength = FilteredData.length;

            if (FilteredData.length != 0) {
               

                Request_List =  FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
                ).map(el => (
                    <tr key={el.requestId}>
                        <td width="5%"><input type="checkbox" ref={'ref_' + el.requestId} id={el.requestId} value={el.requestId} className="RequestRows TenantZones_child_Check_box" disabled={el.IsPastRequest} /></td>
                        <td width="20%">
                            {
                                lUserCanEdit ? <label style={{ color: '#6890C6' }} onClick={() => { this.LoadRequestForEdit(el.requestId, el.IsPastRequest) }} className="link_cursor">{el.tenantName}</label> :
                                    <label className="link_cursor">{el.tenantName}</label>
                            }
                        </td>
                        <td width="25%">{el.zoneName}, {el.buildingName} </td>
                        <td width="20%">
                            {new Intl.DateTimeFormat('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(TimeString.GetDateString(el.startDateTime)))}
                        </td>
                        <td width="15%">
                            {TimeString.GetTimeString(el.startDateTime)} - {TimeString.GetTimeString(el.stopDateTime)}
                        </td>
                        <td width="15%">{el.createdBy}</td>
                    </tr>
                )) : <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr> ; 
            }
            else {
                Request_List = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
            }
            if(Request_List !== undefined){
                lCurrentRequestlength = Request_List.length;
            }
        }
        else if (!this.state.isloading) {
            Request_List = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
        }
        else {
            Request_List = <tr><td colSpan="6" style={{ textAlign: 'center' }}><LoadingIndicator /></td></tr>
        }

        if (this.state.TenantId > 0) {
            Default_Tenant_Id = this.state.TenantId;
        }
        else {
            if (this.props.Tenant_List_Response.TenantsList != undefined) {
                var tenantList = this.props.Tenant_List_Response.TenantsList.filter(el => el.isWorkOrder !== true);
                if (tenantList.length > 0) {
                    Default_Tenant_Id = tenantList[0].tenantId;
                }
            }
        }

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.req_selection_error_alt}</p> : Error_Message = " ";

        return (
            <div className="main_container">
                {Error_Message}

                {/* Options group */}
                <div className="buttons_container">
                    <Button type="button" id='btn_Request_delete' hidden={!lUserCanEdit} className="btn-black" onClick={this.deleteRequests}>{label['Requests.btnDelete.Text']} </Button>
                    <Button type="button" id='btn_Request_add' hidden={!lUserCanEdit} className="btn-success" onClick={this.toggle}>{label['Requests.btnAddRequest.Text']}</Button>
                    <label id="report_num_of_records_within_this_page"  style={{ marginRight: '-15px' }} className="child_tab_paginationtext">{(lRequestlength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + (lRequestlength !== 0 ? ((this.state.currentPage*50) + lCurrentRequestlength):0) + " of " + lRequestlength + " records"}</label>
                    <SearchInput id='src_request_input' className="search-input" onChange={this.searchUpdated} />
                    <div style={{"display": "inline-block", "float": "right"}}>
                        <label>{label !== undefined ? label['AfterHours.Filters.Header.Text'] : "Viewing"}</label>
                        <select ref='filter_in_Select_input' id='ddl_Request_filter' className="pmminimal pm-dropdown Request_Filter_ddl" value={this.state.FilterValue} onChange={this.OnFilterChange}>
                            {Filters_in_Select_input}
                        </select>
                    </div>

                    <div className="date_range_filter RequestDateFilter" id='dt_Request_start' style={{ width: '119px', marginRight: '10px' }}>
                        <DatePicker className="Form_Datepicker date_filter" 
                            customInput={<DatePickerCustom width = '80%'/>}
                            selected={this.state.endDate} isClearable={true}
                            onChange={this.handleChange2} showDisabledMonthNavigation
                            dateFormat={UserFormat} 
                             />
                    </div>
                    <label className="float-left">{label['AfterHours.To.Text']}</label>
                    <div className="date_range_filter RequestDateFilter" id='dt_Request_end' style={{ width: '119px', marginRight: '10px' }}>
                        <DatePicker style={{ "width": "20px"}} className="Form_Datepicker date_filter"
                            customInput={<DatePickerCustom  width = '80%' />}
                            selected={this.state.startDate} isClearable={true}
                            onChange={this.handleChange} placeholderText="Click to select a date"
                            dateFormat={UserFormat} />
                    </div>
                    <label className="float-left">{label['AfterHours.From.Text']}</label>
                </div>

                {/* Table Container */}
                <div className="table_container">
                    <Table striped responsive className="Custom_table table_border" id='tbl_list_Requests'>
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th><input type="checkbox" className="heading_Check_box" onClick={() => { SelectAllCheckboxes.selectAllRequestCheckbox("RequestRows", "heading_Check_box"); }} /></th>
                                <th onClick={this.onSort('tenantName')} className="link_cursor">{label['Requests.Columns.Tenant.Text']}<span className={this.setArrow('tenantName')}></span> </th>
                                <th onClick={this.onSort('zoneName')} className="link_cursor">{label['Requests.Columns.Place.Text']} <span className={this.setArrow('zoneName')}></span> </th>
                                <th onClick={this.onSort('startDateTime')} className="link_cursor">{label['Requests.Columns.Date.Text']}<span className={this.setArrow('startDateTime')}></span> </th>
                                <th onClick={this.onSort('Time')} className="link_cursor">{label['Requests.Columns.Time.Text']}<span className={this.setArrow('Time')}></span> </th>
                                <th onClick={this.onSort('createdBy')} className="link_cursor">{label['Requests.Columns.Employee.Text']} <span className={this.setArrow('createdBy')}></span> </th>
                            </tr>
                            {Request_List}
                        </tbody>
                    </Table>
                </div>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{ width: '450px' }} >
                    <AddRequest CloseModal={this.CloseModal} CloseModal2={this.CloseModal2} DefaultId={Default_Tenant_Id} RequestId={[this.state.RequestId]} TenantName={[this.state.TenantName]} ZoneName={[this.state.zoneName]} IsPastRequest={this.state.IsPastRequest} />
                </Modal>

                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <DeleteConfirmation parentToChildData={["Delete Request", "You are about to delete a tenant request from the system. Do you want to continue?", "Close Window", "Delete Tenant Request"]} Delete={this.Delete} />
                </Modal>

                <div className="row row_padding pm_pagination" style={{ 'marginLeft': '0px' }}>
                            <div className="col-md-7">
                                <ReactPaginate
                                    previousLabel={'Prev'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me pagination_margin'}
                                    breakLinkClassName={'pagination_link_color'}
                                    pageCount={pagesCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={10}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'pagination pagination_container_margin'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    disabledClassName={'pagination_disable_link'}
                                    pageClassName={'pagination_margin'}
                                    pageLinkClassName={'pagination_link_color'}
                                    previousClassName={'pagination_margin'}
                                    previousLinkClassName={'pagination_link_color'}
                                    nextClassName={'pagination_margin'}
                                    nextLinkClassName={'pagination_link_color'}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        </div>

            </div>

        );
    }
}


const mapStateToProps = state => {
    return {
        Tenant_List_Response: state.tenantsRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        RequestList_Response: state.RequestRootReducer.AllRequests,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess,
        PastRequest: state.RequestRootReducer.AllPastRequests
    };
};

const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        DeleteTenantRequests: (data) => dispatch(DeleteTenantRequests(data)),
        GetAllRequests: () => dispatch(GetAllRequests()),
        GetAllPastRequests: (fromDate, toDate) => dispatch(GetAllPastRequests(fromDate, toDate))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Requests);
